import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { ATTACHMENT_TRANSFER, ATTACHMENT_VIEW } from '../constants';

const DatasetAttachmentCardItemExtra = ({ transferable, viewing }) => (
  <Card.Content extra>
    <span>
      <Icon name={ATTACHMENT_VIEW[viewing].icon} />
      <FormattedMessage id={`dataset.attachments.viewing.verbose.${viewing}`} />
    </span>
          &nbsp;&nbsp;&nbsp;&nbsp;
    <span>
      <Icon name={ATTACHMENT_TRANSFER[transferable].icon} />
      <FormattedMessage id={`dataset.attachments.transferable.verbose.${transferable}`} />
    </span>
  </Card.Content>
);

export default DatasetAttachmentCardItemExtra;
